import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { DirtyStateService } from '@shared/services/dirty-state/dirty-state.service';
import { UnsavedChangesService } from '@shared/services/unsaved-state/unsaved-changes.service';

export const unsavedChangesGuard: CanDeactivateFn<unknown> = async () => {
  const dirty = inject(DirtyStateService);
  const modal = inject(UnsavedChangesService);

  if (!dirty.isDirty()) return true;

  const confirmed = await modal.confirm();
  if (confirmed) dirty.clear();
  return confirmed;
};
